var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29199 3.22363L4.02533 3.52363L4.82783 13.0845C4.89199 13.8653 5.54449 14.4645 6.32783 14.462H15.4187C16.1662 14.4636 16.8003 13.9136 16.9062 13.1736L17.697 7.70863C17.7853 7.0978 17.3612 6.53113 16.7512 6.4428C16.6978 6.4353 4.30366 6.43113 4.30366 6.43113",
    stroke: "#1E232C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.771 9.5109H14.0818",
    stroke: "#1E232C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96212 17.3506C6.21296 17.3506 6.41546 17.5539 6.41546 17.8039C6.41546 18.0548 6.21296 18.2581 5.96212 18.2581C5.71129 18.2581 5.50879 18.0548 5.50879 17.8039C5.50879 17.5539 5.71129 17.3506 5.96212 17.3506Z",
    fill: "#1E232C",
    stroke: "#1E232C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3625 17.3506C15.6133 17.3506 15.8167 17.5539 15.8167 17.8039C15.8167 18.0548 15.6133 18.2581 15.3625 18.2581C15.1117 18.2581 14.9092 18.0548 14.9092 17.8039C14.9092 17.5539 15.1117 17.3506 15.3625 17.3506Z",
    fill: "#1E232C",
    stroke: "#1E232C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.4835210c9cd281af4a3e59097f14dc66.svg";
export { ForwardRef as ReactComponent };